<template>
    <ai-form-text-box-dictionary
        ref="tboxDogCtxRef"
        title="Договорной Контекст"
        placeholder=""
        :field-key="meta.fieldNameId"
        :field-name-id="meta.fieldNameId"
        :field-name-text="meta.fieldNameText"
        :key-expr="meta.keyExpr"
        :value-expr="meta.keyExpr"
        :display-expr="meta.displayExpr"
        :data-source="dict"
        :custom-buttons="customButtons"
        :need-modified-class="false"
        @popup-shown="popupShown"
    >
        <CtxDogData />

        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Выбрать" @click="chooseItem" />
        </dx-toolbar-item>

        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Отмена" @click="hide" />
        </dx-toolbar-item>
    </ai-form-text-box-dictionary>
</template>

<script setup>
import { ref, computed, reactive, inject, onMounted } from 'vue';
import { bridge } from '@/views/history/history-card/history-bridge';

import { DxButton } from 'devextreme-vue/button';
import { DxToolbarItem } from 'devextreme-vue/popup';

import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
import CtxDogData from '@/views/history/history-card/components/ctx-dog-tree.vue';

const depEmpTreeRef = ref(null);
const tboxDogCtxRef = ref(null);
const popupInstance = ref(null);

const userData = inject('userData');

const meta = {
    // используется только в input, в popup не используется
    fieldKey: 'who_id',
    fieldNameId: 'who_id',
    fieldNameText: 'who_name',

    // используется в input и popup
    keyExpr: 'key',
    displayExpr: 'name',
    parentIdExpr: 'parent_id',

    // используется только в popup
    searchHint: null,
    valueChangeEvent: 'keyup',
    rootValue: null,
    dataStructure: 'plain',
    selectByClick: true,
    expandEvent: 'dblclick',
    selectionMode: 'single',
    itemTemplate: 'item-template',
};

const dict = computed(() => {
    if(Object.keys(userData.value).length === 0){
        return [];
    }
    return [
        {
            [`${meta.keyExpr}`]: userData.value[meta.fieldNameId],
            [`${meta.displayExpr}`]: userData.value[meta.fieldNameText],
        },
    ];
});

const customButtons = reactive([
    {
        name: 'clearButton',
        options: {
            visible: true,
            disabled: false,
            icon: 'close',
            onClick: async () => {
                userData.value[meta.fieldNameId] = null;
                userData.value[meta.fieldNameText] = null;
                await bridge.cardCallbacks.onChangeData(userData.value);
            },
        },
    },
]);

onMounted(() => {
    bridge.addUpdateControlCallback(setData);
    popupInstance.value = tboxDogCtxRef.value?.popupInstance;
});

const hide = () => {
    popupInstance.value.instance().hide();
};

const chooseItem = async () => {
    if (depEmpTreeRef.value.selectedItem) {
        userData.value[meta.fieldNameId] = depEmpTreeRef.value.selectedItem.key;
        userData.value[meta.fieldNameText] = depEmpTreeRef.value.selectedItem.name;
    } else {
        userData.value[meta.fieldNameId] = null;
        userData.value[meta.fieldNameText] = null;
    }

    bridge.debug({ ref: depEmpTreeRef, data: userData.value });
    await bridge.cardCallbacks.onChangeData(userData.value);

    hide();
};

const popupShown = () => {
    if (userData.value[meta.fieldNameId]) {
        depEmpTreeRef.value.selectNode(userData.value[meta.fieldNameId])
    }
};

const setData = changes => {
    userData.value[meta.fieldNameId] = changes[meta.fieldNameId];
    userData.value[meta.fieldNameText] = changes[meta.fieldNameText];
};

defineExpose({
    setData,
});
</script>
